export default __webpack_public_path__ + "images/afc46689866aef8b728b31bdac7218ea.svg";